export default {
    tooltip: 'This trend is no longer linked by Trendone to current micro trends.'
}
